<script>
export default {
  props: ["employee_data"],
  data() {
    return {
      HrEmployeesWeeklyWorkingHours: [],
      hr_weekdays: [],
      weeklyWorkingHoursPage: 1,
      weeklyWorkingHoursLimit: 20,
      totWeeklyWorkingHoursPages: 0,
      HrEmployeesMonthlyWorkingHours: [],
      HrEmployeesWorkRestPattern: [],
      hr_monthdays: [],
      monthlyWorkingHoursPage: 1,
      monthlyWorkingHoursLimit: 20,
      totMonthlyWorkingHoursPages: 0,
      workRestPatternPage: 1,
      workRestPatternLimit: 20,
      totWorkRestPatternPages: 0,
      weekdays: [
        { id: 1, name: "Saturday" },
        { id: 2, name: "Sunday" },
        { id: 3, name: "Monday" },
        { id: 4, name: "Tuesday" },
        { id: 5, name: "Wednesday" },
        { id: 6, name: "Thursday" },
        { id: 7, name: "Friday" },
      ],
      hrWorkingScheduleTypes: {},
      config: {},
      shiftSchedule: {},
      weeklyWorkingHours: {
        shifts: [
          {
            start_time: "",
            end_time: "",
          },
        ],
      },
      monthlyWorkingHours: {
        shifts: [
          {
            start_time: "",
            end_time: "",
          },
        ],
      },
    };
  },
  methods: {
    dismissModal() {
      let btns = document.querySelectorAll(".btn-close");
      btns.forEach((btn) => {
        btn.click();
      });
    },
    getHrEmployeesWeeklyWorkingHours(page, tabClick) {
      console.log("1-the seconde one ");
      if (this.HrEmployeesWeeklyWorkingHours.length > 0 && tabClick) return;
      this.http
        .post("hr-employees-working-hours/hr-employee-working-hours", {
          limit: this.weeklyWorkingHoursLimit,
          page: page,
          employee_id: parseInt(this.$route.params.id),
        })
        .then((res) => {
          this.weeklyWorkingHoursPage = page;
          this.HrEmployeesWeeklyWorkingHours = res.data;
          this.totWeeklyWorkingHoursPages = Math.ceil(
            res.tot / this.weeklyWorkingHoursLimit
          );
          console.log("pagessss", this.totWeeklyWorkingHoursPages);

          this.HrEmployeesWeeklyWorkingHours.forEach((day) => {
            this.weekdays.forEach((week) => {
              if (week.id == day.weekday) {
                day.day = week.name;
              }
            });
          });
        });
    },

    getHrEmployeesMonthlyWorkingHours(page, tabClick) {
      console.log("1-the third one");
      if (this.HrEmployeesMonthlyWorkingHours.length > 0 && tabClick) return;
      this.http
        .post("hr-employees-working-hours/hr-employee-monthly-working-hours", {
          limit: this.monthlyWorkingHoursLimit,
          page: page,
          employee_id: parseInt(this.$route.params.id),
        })
        .then((res) => {
          this.monthlyWorkingHoursPage = page;
          this.totMonthlyWorkingHoursPages = Math.ceil(
            res.tot / this.monthlyWorkingHoursLimit
          );

          // Get current year and month
          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth(); // 0-based (May = 4)
          const weekdayMap = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];

          this.HrEmployeesMonthlyWorkingHours = res.data
            .sort((a, b) => a.day - b.day)
            .map((item) => {
              const date = new Date(year, month, item.day); // build date using year, month, and day
              const dayName = weekdayMap[date.getDay()];

              return {
                id: item.id,
                day: item.day,
                dayName,
                start_time: item.start_time,
                end_time: item.end_time,
              };
            });
        });
    },

    getHrEmployeesWorkRestPattern(page, tabClick) {
      console.log("1-the fourth one");
      if (this.HrEmployeesWorkRestPattern.length > 0 && tabClick) return;
      this.http
        .post("hr-employees-working-hours/hr-employee-work-rest-pattern", {
          limit: this.workRestPatternLimit,
          page: page,
          employee_id: parseInt(this.$route.params.id),
        })
        .then((res) => {
          this.workRestPatternPage = page;
          this.totWorkRestPatternPages = Math.ceil(
            res.tot / this.workRestPatternLimit
          );
          this.HrEmployeesWorkRestPattern = res.data;
        });
    },

    addHrEmployeesWeeklyWorkingHours() {
      this.weeklyWorkingHours.hr_employee_id = parseInt(this.$route.params.id);
      this.http
        .post("hr-employees-working-hours", this.weeklyWorkingHours)
        .then(() => {
          this.getHrEmployeesWeeklyWorkingHours(
            this.weeklyWorkingHoursPage,
            false
          );
          this.weeklyWorkingHours = {
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
          };
          this.dismissModal();
        });
    },

    addHrEmployeesMonthlyWorkingHours() {
      this.monthlyWorkingHours.hr_employee_id = parseInt(this.$route.params.id);
      this.http
        .post(
          "hr-employees-working-hours/hr-employees-monthly-working-hours",
          this.monthlyWorkingHours
        )
        .then(() => {
          this.getHrEmployeesMonthlyWorkingHours(
            this.monthlyWorkingHoursPage,
            false
          );
          this.monthlyWorkingHours = {
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
          };
          this.dismissModal();
        });
    },

    editHrEmployeesWeeklyWorkingHours(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "weekday_id",
            type: "select",
            value: app.weekday_id,
            options: (() => {
              return this.hr_weekdays.map((data) => {
                return {
                  value: data.id,
                  label: this.$i18n.locale === "en" ? data.name_en : data.name,
                };
              });
            })(),
            label: "Week Day",
          },
          {
            model: "start_time",
            type: "time",
            label: "Start Time",
            value: app.start_time,
          },
          {
            model: "end_time",
            type: "time",
            label: "End Time",
            value: app.end_time,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.hr_employee_id = this.employee_data?.id;
              this.http
                .put("hr-employees-working-hours", app.id, obj)
                .then(() => {
                  this.getHrEmployeesWeeklyWorkingHours(
                    this.weeklyWorkingHoursPage
                  );
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrEmployeesMonthlyWorkingHours(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "day",
            type: "select",
            value: app.day,
            options: (() => {
              return this.hr_monthdays.map((data) => {
                return {
                  value: data.id,
                  label: this.$i18n.locale === "en" ? data.name_en : data.name,
                };
              });
            })(),
            label: "Month Day",
          },
          {
            model: "start_time",
            type: "time",
            label: "Start Time",
            value: app.start_time,
          },
          {
            model: "end_time",
            type: "time",
            label: "End Time",
            value: app.end_time,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.hr_employee_id = this.employee_data?.id;
              obj.id = app.id;
              this.http
                .post(
                  "hr-employees-working-hours/update-hr-employees-monthly-working-hours",
                  obj
                )
                .then(() => {
                  this.getHrEmployeesMonthlyWorkingHours(
                    this.monthlyWorkingHoursPage
                  );
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrEmployeesWorkRestPattern(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "start_time",
            type: "time",
            label: "Start Time",
            value: app.start_time?.substring(0, 5),
          },
          {
            model: "end_time",
            type: "time",
            label: "End Time",
            value: app.end_time?.substring(0, 5),
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.hr_employee_id = this.employee_data?.id;
              obj.id = app.id;
              this.http
                .post(
                  "hr-employees-working-hours/update-hr-employees-work-rest-pattern",
                  obj
                )
                .then(() => {
                  this.getHrEmployeesWorkRestPattern(this.workRestPatternPage);
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    addWorkRestPatternShift(app) {
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "start_time",
            type: "time",
            label: "Start Time",
          },
          {
            model: "end_time",
            type: "time",
            label: "End Time",
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.hr_employee_id = this.employee_data?.id;
              obj.day = app.day;
              this.http
                .post(
                  "hr-employees-working-hours/hr-employees-work-rest-pattern-shift",
                  obj
                )
                .then(() => {
                  this.getHrEmployeesWorkRestPattern(this.workRestPatternPage);
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    deleteHrEmployeesWeeklyWorkingHours(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("hr-employees-working-hours", app.id).then(() => {
            this.getHrEmployeesWeeklyWorkingHours(
              this.weeklyWorkingHoursPage,
              false
            );
          });
        }
      });
    },

    deleteHrEmployeesMonthlyWorkingHours(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http
            .post(
              "hr-employees-working-hours/delete-hr-employees-monthly-working-hours",
              {
                id: app.id,
              }
            )
            .then(() => {
              this.getHrEmployeesMonthlyWorkingHours(
                this.monthlyWorkingHoursPage,
                false
              );
            });
        }
      });
    },

    deleteHrEmployeesWorkRestPattern(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http
            .post(
              "hr-employees-working-hours/delete-hr-employees-work-rest-pattern",
              {
                id: app.id,
              }
            )
            .then(() => {
              this.getHrEmployeesWorkRestPattern(
                this.workRestPatternPage,
                false
              );
            });
        }
      });
    },

    getHrWeekDays() {
      console.log("1-hre wekk");
      this.http.get("hr-employees-working-hours/weekdays").then((res) => {
        this.hr_weekdays = res.data;
      });
    },
    getHrScheduleTypes() {
      console.log("1-the schduler");
      this.http
        .get("hr-employees-working-hours/hr-working-schedule-types")
        .then((res) => {
          this.hrWorkingScheduleTypes = res.data;
        });
    },
    getConfig() {
      console.log("1-the condif");
      this.http.get("emps/config").then((res) => {
        this.config = res.data.reduce((acc, item) => {
          acc[item.name_en] = item.value;
          return acc;
        }, {});
      });
    },
    initializeShiftData(data) {
      this.shiftSchedule = data?.working_schedule_type;
      console.log("Employee data loaded:", data);
    },
    getLocalizedDay(config) {
      return config;
    },
  },
  mounted() {
    const daysInMonth = 31;
    console.log("empp", this.employee_data);
    this.hr_monthdays = Array.from({ length: daysInMonth }, (_, i) => {
      return {
        id: i + 1,
        name: `يوم ${i + 1}`,
        name_en: `Day ${i + 1}`,
      };
    });
  },
  created() {
    this.getHrWeekDays();
    this.getHrEmployeesWeeklyWorkingHours(1, true);
    this.getHrEmployeesMonthlyWorkingHours(1, true);
    this.getHrEmployeesWorkRestPattern(1, true);
    this.getHrScheduleTypes();
    this.getConfig();
  },
  watch: {
    employee_data: {
      handler(newVal) {
        console.log("the newVal", newVal);
        console.log("the imployy", this.employee_data);
        if (newVal && Object.keys(newVal).length > 0) {
          this.initializeShiftData(newVal);
        }
      },
      immediate: true, // runs the watcher immediately if the prop is already set
      deep: true,
    },
  },
  computed: {
    groupedWorkingHours() {
      const groups = {};

      for (const row of this.HrEmployeesMonthlyWorkingHours) {
        if (!groups[row.day]) {
          groups[row.day] = [];
        }
        groups[row.day].push(row);
      }

      return Object.entries(groups).sort((a, b) => a[0] - b[0]);
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div v-if="shiftSchedule.code == 'weekly'">
      <div class="card shadow-sm border-0 rounded-4">
        <div
          class="card-header text-white fw-semibold d-flex align-items-center rounded-top-2"
          style="background-color: #166fd4"
        >
          <i class="fas fa-calendar-alt me-2"></i>
          {{ $t("hr_employees.shift.weekly_schedule_settings") }}
        </div>
        <div class="card-body bg-light rounded-bottom-4">
          <div class="row text-center">
            <!-- Week Start -->
            <div class="col-md-3 mb-3">
              <div class="p-3 bg-white rounded-3 shadow-sm">
                <div class="text-muted small">
                  {{ $t("hr_employees.shift.week_start") }}
                </div>
                <div class="fw-bold fs-5 mt-1">
                  {{
                    $i18n.locale === "en"
                      ? config["Working Week Start Day"]
                      : config["Working Day Start Time"]
                  }}
                </div>
              </div>
            </div>

            <!-- Week End -->
            <div class="col-md-3 mb-3">
              <div class="p-3 bg-white rounded-3 shadow-sm">
                <div class="text-muted small">
                  {{ $t("hr_employees.shift.week_end") }}
                </div>
                <div class="fw-bold fs-5 mt-1">
                  {{
                    $i18n.locale === "en"
                      ? config["Working Week End Day"]
                      : config["Working Week End Day"]
                  }}
                </div>
              </div>
            </div>

            <!-- Daily Start Time -->
            <div class="col-md-3 mb-3">
              <div class="p-3 bg-white rounded-3 shadow-sm">
                <div class="text-muted small">
                  {{ $t("hr_employees.shift.daily_start_time") }}
                </div>
                <div class="fw-bold fs-5 mt-1">
                  {{ config["Working Day Start Time"] }}
                </div>
              </div>
            </div>

            <!-- Daily Start Time -->
            <div class="col-md-3 mb-3">
              <div class="p-3 bg-white rounded-3 shadow-sm">
                <div class="text-muted small">
                  {{ $t("hr_employees.shift.daily_finish_time") }}
                </div>
                <div class="fw-bold fs-5 mt-1">
                  {{ config["Working Day Finish Time"] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shiftSchedule.code == 'shift_based'">
      <div class="row">
        <div class="col-6"></div>
        <div class="col-6" style="display: flex; justify-content: flex-end">
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#addEmployeesWeeklyWorkingHoursModal"
            class="btn btn-light float-end mb-4"
          >
            <span
              class="bx bxs-plus-circle float-end fa-2x"
              style="color: #2a3042 !important"
            ></span>
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table
          :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
          class="table table-bordered dt-responsive align-middle"
        >
          <thead>
            <tr
              class="text-light text-center"
              style="background-color: #2a3042 !important"
            >
              <th scope="col">{{ $t("hr_employees.id") }}</th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.weekday") }}
              </th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.start_time") }}
              </th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.end_time") }}
              </th>
              <th scope="col">{{ $t("hr_employees.operations") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(app, length) in HrEmployeesWeeklyWorkingHours"
              :key="app"
              class="text-center"
            >
              <td>{{ length + 1 }}</td>
              <td>
                {{
                  $i18n.locale == "ar"
                    ? app?.weekday?.name
                    : app?.weekday?.name_en
                }}
              </td>
              <td>
                {{ moment(app?.start_time, "HH:mm:ss").format("hh:mm A") }}
              </td>
              <td>{{ moment(app?.end_time, "HH:mm:ss").format("hh:mm A") }}</td>

              <td class="d-flex">
                <a
                  class="btn btn-primary mx-1"
                  @click="editHrEmployeesWeeklyWorkingHours(app)"
                  href="javascript: void(0);"
                  role="button"
                  >{{ $t("popups.edit") }}</a
                >
                <a
                  class="btn btn-danger"
                  href="javascript: void(0);"
                  role="button"
                  @click="deleteHrEmployeesWeeklyWorkingHours(app)"
                  >{{ $t("popups.delete") }}</a
                >
              </td>
            </tr>
          </tbody>
        </table>
        <!-- end  table -->
      </div>

      <div>
        <!--   Apps  Pagination     -->
        <ul class="pagination pagination-rounded justify-content-center mb-2">
          <li
            class="page-item"
            :class="{ disabled: weeklyWorkingHoursPage == 1 }"
          >
            <a
              class="page-link"
              href="javascript: void(0);"
              @click="
                getHrEmployeesWeeklyWorkingHours(
                  weeklyWorkingHoursPage - 1,
                  false
                )
              "
              aria-label="Previous"
            >
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>
          <li
            class="page-item"
            :class="{ active: p == weeklyWorkingHoursPage }"
            v-for="p in totWeeklyWorkingHoursPages"
            :key="p"
          >
            <a
              class="page-link"
              href="javascript: void(0);"
              @click="getHrEmployeesWeeklyWorkingHours(p, false)"
              >{{ p }}</a
            >
          </li>

          <li
            class="page-item"
            :class="{
              disabled: weeklyWorkingHoursPage == totWeeklyWorkingHoursPages,
            }"
          >
            <a
              class="page-link"
              href="javascript: void(0);"
              @click="
                getHrEmployeesWeeklyWorkingHours(
                  weeklyWorkingHoursPage + 1,
                  false
                )
              "
              aria-label="Next"
            >
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <!--end-->
    </div>
    <div v-if="shiftSchedule.code == 'work_rest_pattern'">
      <div class="card shadow-sm border-0 rounded-4">
        <div
          class="card-header text-white fw-semibold d-flex align-items-center rounded-top-2"
          style="background-color: #20c997"
        >
          <i class="fas fa-random me-2"></i>
          {{ $t("hr_employees.shift.work_rest_pattern_settings") }}
        </div>

        <div class="card-body bg-light rounded-bottom-4">
          <!-- Summary -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="p-3 bg-white rounded-3 shadow-sm">
                <div class="text-muted small">
                  {{ $t("hr_employees.shift.work_days") }}
                </div>
                <div class="fw-bold fs-5 mt-1">
                  {{ employee_data.work_days }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="p-3 bg-white rounded-3 shadow-sm">
                <div class="text-muted small">
                  {{ $t("hr_employees.shift.rest_days") }}
                </div>
                <div class="fw-bold fs-5 mt-1">
                  {{ employee_data.rest_days }}
                </div>
              </div>
            </div>
          </div>

          <!-- Pattern Setup Table -->
          <div class="table-responsive">
            <table class="table table-bordered text-center">
              <thead class="bg-secondary text-white">
                <tr>
                  <th>#</th>
                  <th>{{ $t("hr_employees.shift.pattern_day") }}</th>
                  <th>{{ $t("hr_employees.shift.start_time") }}</th>
                  <th>{{ $t("hr_employees.shift.end_time") }}</th>
                  <th>{{ $t("hr_employees.operations") }}</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="row in HrEmployeesWorkRestPattern"
                  :key="'day-' + row.day"
                >
                  <!-- Parent Row Showing Day -->
                  <tr style="background-color: #f0f0f0; font-weight: bold">
                    <td></td>
                    <td>{{ $t("hr_employees.shift.day") }} {{ row.day }}</td>
                    <td colspan="2"></td>
                    <td>
                      <a
                        class="btn btn-light btn-sm mx-1"
                        type="button"
                        @click="addWorkRestPatternShift(row)"
                        href="javascript:void(0);"
                        role="button"
                      >
                        <span
                          class="bx bxs-plus-circle float-end fa-2x"
                          style="color: #2a3042 !important"
                        ></span>
                      </a>
                    </td>
                  </tr>

                  <!-- Child rows for shifts -->
                  <tr
                    v-for="(shift, i) in row.shifts"
                    :key="'shift-' + shift.id"
                  >
                    <td>{{ i + 1 }}</td>
                    <td></td>
                    <td>
                      {{
                        moment(shift.start_time, "HH:mm:ss").format("hh:mm A")
                      }}
                    </td>
                    <td>
                      {{ moment(shift.end_time, "HH:mm:ss").format("hh:mm A") }}
                    </td>
                    <td class="d-flex justify-content-center">
                      <a
                        class="btn btn-primary btn-sm mx-1"
                        @click="editHrEmployeesWorkRestPattern(shift)"
                        href="javascript:void(0);"
                        role="button"
                      >
                        {{ $t("popups.edit") }}
                      </a>
                      <a
                        v-if="row.shifts.length > 1"
                        class="btn btn-danger btn-sm"
                        @click="deleteHrEmployeesWorkRestPattern(shift)"
                        href="javascript:void(0);"
                        role="button"
                      >
                        {{ $t("popups.delete") }}
                      </a>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <!-- Pagination -->
            <ul
              class="pagination pagination-rounded justify-content-center mb-2"
            >
              <li
                class="page-item"
                :class="{ disabled: workRestPatternPage == 1 }"
              >
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="
                    getHrEmployeesWorkRestPattern(
                      workRestPatternPage - 1,
                      false
                    )
                  "
                  aria-label="Previous"
                >
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li
                class="page-item"
                :class="{ active: p == workRestPatternPage }"
                v-for="p in totWorkRestPatternPages"
                :key="p"
              >
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="getHrEmployeesWorkRestPattern(p, false)"
                  >{{ p }}</a
                >
              </li>
              <li
                class="page-item"
                :class="{
                  disabled: workRestPatternPage == totWorkRestPatternPages,
                }"
              >
                <a
                  class="page-link"
                  href="javascript:void(0);"
                  @click="
                    getHrEmployeesWorkRestPattern(
                      workRestPatternPage + 1,
                      false
                    )
                  "
                  aria-label="Next"
                >
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shiftSchedule.code == 'monthly_days'">
      <div class="row">
        <div class="col-6"></div>
        <div class="col-6" style="display: flex; justify-content: flex-end">
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#addEmployeesMonthlyWorkingHoursModal"
            class="btn btn-light float-end mb-4"
          >
            <span
              class="bx bxs-plus-circle float-end fa-2x"
              style="color: #2a3042 !important"
            ></span>
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table
          :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
          class="table table-bordered dt-responsive align-middle"
        >
          <thead>
            <tr
              class="text-light text-center"
              style="background-color: #2a3042 !important"
            >
              <th scope="col">{{ $t("hr_employees.id") }}</th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.monthday") }}
              </th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.weekday") }}
              </th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.start_time") }}
              </th>
              <th scope="col">
                {{ $t("hr_employees.employee_profile.end_time") }}
              </th>
              <th scope="col">{{ $t("hr_employees.operations") }}</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="([day, records], length) in groupedWorkingHours"
              :key="day"
            >
              <!-- If only one shift -->
              <tr v-if="records.length === 1" class="text-center">
                <td>{{ length + 1 }}</td>
                <td>{{ "Day " + records[0].day }}</td>
                <td>{{ records[0].dayName }}</td>
                <td>
                  {{
                    moment(records[0].start_time, "HH:mm:ss").format("hh:mm A")
                  }}
                </td>
                <td>
                  {{
                    moment(records[0].end_time, "HH:mm:ss").format("hh:mm A")
                  }}
                </td>
                <td class="d-flex justify-content-center">
                  <a
                    class="btn btn-primary mx-1"
                    @click="editHrEmployeesMonthlyWorkingHours(records[0])"
                  >
                    {{ $t("popups.edit") }}
                  </a>
                  <a
                    class="btn btn-danger"
                    @click="deleteHrEmployeesMonthlyWorkingHours(records[0])"
                  >
                    {{ $t("popups.delete") }}
                  </a>
                </td>
              </tr>

              <!-- If multiple shifts -->
              <template v-else>
                <!-- Header row -->
                <tr style="background-color: #f8f9fa" class="text-center">
                  <td>{{ length + 1 }}</td>
                  <td>{{ "Day " + records[0].day }}</td>
                  <td colspan="4" class="fw-bold">
                    {{ $t("hr_employees.employee_profile.shifts") }}
                  </td>
                </tr>

                <!-- Shift rows -->
                <tr
                  v-for="record in records"
                  :key="record.id"
                  class="text-center"
                >
                  <td></td>
                  <td></td>
                  <td>{{ record.dayName }}</td>
                  <td>
                    {{
                      moment(record.start_time, "HH:mm:ss").format("hh:mm A")
                    }}
                  </td>
                  <td>
                    {{ moment(record.end_time, "HH:mm:ss").format("hh:mm A") }}
                  </td>
                  <td class="d-flex justify-content-center">
                    <a
                      class="btn btn-primary mx-1"
                      @click="editHrEmployeesMonthlyWorkingHours(record)"
                    >
                      {{ $t("popups.edit") }}
                    </a>
                    <a
                      class="btn btn-danger"
                      @click="deleteHrEmployeesMonthlyWorkingHours(record)"
                    >
                      {{ $t("popups.delete") }}
                    </a>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
        <!-- end  table -->
      </div>

      <div>
        <!--   Apps  Pagination     -->
        <ul class="pagination pagination-rounded justify-content-center mb-2">
          <li
            class="page-item"
            :class="{ disabled: monthlyWorkingHoursPage == 1 }"
          >
            <a
              class="page-link"
              href="javascript: void(0);"
              @click="
                getHrEmployeesMonthlyWorkingHours(
                  monthlyWorkingHoursPage - 1,
                  false
                )
              "
              aria-label="Previous"
            >
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>
          <li
            class="page-item"
            :class="{ active: p == monthlyWorkingHoursPage }"
            v-for="p in totMonthlyWorkingHoursPages"
            :key="p"
          >
            <a
              class="page-link"
              href="javascript: void(0);"
              @click="getHrEmployeesMonthlyWorkingHours(p, false)"
              >{{ p }}</a
            >
          </li>

          <li
            class="page-item"
            :class="{
              disabled: monthlyWorkingHoursPage == totMonthlyWorkingHoursPages,
            }"
          >
            <a
              class="page-link"
              href="javascript: void(0);"
              @click="
                getHrEmployeesMonthlyWorkingHours(
                  monthlyWorkingHoursPage + 1,
                  false
                )
              "
              aria-label="Next"
            >
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <!--end-->
    </div>
    <div v-if="shiftSchedule.code == 'on_call'">
      <b-card
        class="text-center border-info shadow-sm"
        bg-variant="light"
        text-variant="dark"
        style="border-left: 5px solid #17a2b8"
      >
        <i class="fas fa-phone-volume text-info me-3 fa-2x"></i>
        <h4 class="mt-2 fw-bold" style="color: #166fd4">
          {{ $t("hr_employees.shift.on_call_schedule_title") }}
        </h4>
        <p class="mb-0 mt-3 text-muted">
          {{ $t("hr_employees.shift.on_call_schedule_description") }}
        </p>
      </b-card>
    </div>
    <div v-if="shiftSchedule.code == 'project_based'">
      <b-card
        class="text-center shadow-sm"
        bg-variant="light"
        text-variant="dark"
        style="border-left: 5px solid #166fd4"
      >
        <i class="fas fa-calendar-alt text-info me-2 fa-2x"></i>
        <h4 class="mt-2 fw-bold" style="color: #166fd4">
          {{ $t("hr_employees.shift.project_based_title") }}
        </h4>

        <p class="mb-0 text-muted">
          {{
            employee_data.basic_salary && employee_data.basic_salary > 0
              ? $t("hr_employees.shift.project_based_with_salary")
              : $t("hr_employees.shift.project_based_without_salary")
          }}
        </p>
      </b-card>
    </div>
  </div>
  <!--Start add Weekly Working Hours Modal-->
  <div
    class="modal fade"
    id="addEmployeesWeeklyWorkingHoursModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <form @submit.prevent="addHrEmployeesWeeklyWorkingHours()">
          <div class="modal-header">
            <h5 class="modal-title w-100" id="exampleModalLabel">
              {{ $t("popups.add") }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="margin: 0; right: auto"
            ></button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_employees.employee_profile.weekday")
              }}</label>
              <select
                id="weekDay"
                v-model="weeklyWorkingHours.hr_weekday_id"
                class="form-select"
              >
                <option disabled value="">
                  {{ $t("hr_employees.employee_profile.select") }}
                </option>
                <option
                  v-for="type in hr_weekdays"
                  :key="type"
                  :value="type.id"
                >
                  {{ $i18n.locale == "ar" ? type?.name : type.name_en }}
                </option>
              </select>
            </div>

            <div class="m-1">
              <!-- Add Shift Button -->
              <div class="col-12 d-flex justify-content-end mb-1">
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  @click="
                    weeklyWorkingHours.shifts.push({
                      start_time: '',
                      end_time: '',
                    })
                  "
                >
                  <span
                    class="bx bxs-plus-circle float-end fa-2x"
                    style="color: #2a3042 !important"
                  ></span>
                </button>
              </div>
              <div
                v-for="(shift, sIndex) in weeklyWorkingHours.shifts"
                :key="sIndex"
                class="row align-items-end mb-2"
              >
                <div class="col">
                  <label class="form-label">{{
                    $t("hr_employees.employee_profile.start_time")
                  }}</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="shift.start_time"
                    required
                  />
                </div>

                <div class="col">
                  <label class="form-label">{{
                    $t("hr_employees.employee_profile.end_time")
                  }}</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="shift.end_time"
                    required
                  />
                </div>

                <div class="col-2 d-flex">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="weeklyWorkingHours.shifts.splice(sIndex, 1)"
                    :disabled="weeklyWorkingHours.shifts.length <= 1"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
            <button type="submit" class="btn btn-primary">
              {{ $t("popups.add") }}
            </button>
            <button
              data-bs-dismiss="modal"
              type="button"
              class="btn btn-danger"
            >
              {{ $t("popups.cancel") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--End add Weekly Working Hours Modal-->

  <!--Start add Monthly Working Hours Modal-->
  <div
    class="modal fade"
    id="addEmployeesMonthlyWorkingHoursModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <form @submit.prevent="addHrEmployeesMonthlyWorkingHours()">
          <div class="modal-header">
            <h5 class="modal-title w-100" id="exampleModalLabel">
              {{ $t("popups.add") }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="margin: 0; right: auto"
            ></button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_employees.employee_profile.monthday")
              }}</label>
              <select
                id="monthDay"
                v-model="monthlyWorkingHours.day"
                class="form-select"
              >
                <option disabled value="">
                  {{ $t("hr_employees.employee_profile.select") }}
                </option>
                <option
                  v-for="type in hr_monthdays"
                  :key="type"
                  :value="type.id"
                >
                  {{ $i18n.locale == "ar" ? type?.name : type.name_en }}
                </option>
              </select>
            </div>

            <div class="m-1">
              <!-- Add Shift Button -->
              <div class="col-12 d-flex justify-content-end mb-1">
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  @click="
                    monthlyWorkingHours.shifts.push({
                      start_time: '',
                      end_time: '',
                    })
                  "
                >
                  <span
                    class="bx bxs-plus-circle float-end fa-2x"
                    style="color: #2a3042 !important"
                  ></span>
                </button>
              </div>
              <div
                v-for="(shift, sIndex) in monthlyWorkingHours.shifts"
                :key="sIndex"
                class="row align-items-end mb-2"
              >
                <div class="col">
                  <label class="form-label">{{
                    $t("hr_employees.employee_profile.start_time")
                  }}</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="shift.start_time"
                    required
                  />
                </div>

                <div class="col">
                  <label class="form-label">{{
                    $t("hr_employees.employee_profile.end_time")
                  }}</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="shift.end_time"
                    required
                  />
                </div>

                <div class="col-2 d-flex">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="monthlyWorkingHours.shifts.splice(sIndex, 1)"
                    :disabled="monthlyWorkingHours.shifts.length <= 1"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
            <button type="submit" class="btn btn-primary">
              {{ $t("popups.add") }}
            </button>
            <button
              data-bs-dismiss="modal"
              type="button"
              class="btn btn-danger"
            >
              {{ $t("popups.cancel") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--End add Monthly Working Hours Modal-->
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
